<template lang="pug">
  div()
    splitpanes.default-theme(:style="{'height':`${height}px`, 'background-color':'#CCCCCC'}" )
      pane(:size="20")
        timeline-side-bar(v-if="vehicle_id"  :items="vehicle_list" :height="height-200")
      pane(:size="80")
        v-layout(ref="contentArea" column )
          template(v-if="$store.state.timeline.avl_data.length > 0")
            timeline(v-if="isLoaded" :height="height-40" )
          template(v-else)
            .fill-height()
              .d-flex.fill-width.justify-center.align-center.font-italic.mt-12.grey--text() no data  |  {{getFormattedDate()}}



</template>
<script>
import Timeline from "@/modules/maps/components/ui/TopSection/Timeline";
import HistoryMap from "@/modules/maps/components/maps/HisotryMap";
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css'
import TimelineSideBar from "@/modules/maps/components/ui/SideBar/TimelineSideBar";
import moment from "moment";



export default {
  components: {
    TimelineSideBar,

    Timeline,
    HistoryMap,
    Splitpanes,
    Pane
  },

  data: () => ({
    height: null,
    width: null,
    track_key:1,
    vehicle_id:null,
    vehicle_list:[],
    isLoaded:false,
  }),
  created() {
    // stretch the elements to fill the height
    this.height = window.innerHeight - 115;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      // this.width = this.$refs.contentArea.getBoundingClientRect().width;
    });
  },

  destroyed() {
    window.removeEventListener('resize',this.onResize)
  },

  methods:{
    onResize:function(){
      this.height = window.innerHeight - 115;
    },
    getFormattedDate() {
      return moment(this.$store.getters["timeline/getDateTimelineRange"].start).format("ddd, Do MMM YYYY")
    },
  },
  mounted() {
    this.vehicle_list = [];
    this.$store.getters["vehicles/devices/getActiveTrackerEnabledDevices"].forEach((item) => {
      this.vehicle_list.push(item.vehicle);
    })
    if (this.vehicle_list.length > 0 ){
      let mapSelectedVehicleId = localStorage.getItem("mapSelectedVehicleId");
      if(mapSelectedVehicleId == null){
        this.vehicle_id = this.vehicle_list[0].id;
        localStorage.setItem("mapSelectedVehicleId", this.vehicle_list[0].id);
        mapSelectedVehicleId = this.vehicle_id
      }else{
        this.vehicle_id = mapSelectedVehicleId;
      }


      this.$store.commit("vehicles/devices/setCurrentIndexByVehicleID", mapSelectedVehicleId);
      this.$store.commit("timeline/setCurrentVehicleID", mapSelectedVehicleId);
      this.$store.commit("trips/setCurrentVehicleID", mapSelectedVehicleId);
    }
    this.$nextTick(() => {
      this.isLoaded = true;
    });

  }
};
</script>
<style scoped lang="stylus">
#trackContiner {
  display: flex;
  background-color: #CCCCCC;
  height: 100%;
  width: 100%;
}

#sideBar {
  background-color: #E80000;
  width: 100%;
  height: 100%;
}

#mainBody {
  background-color: #00CC00;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

#showHideSideBar {
  background-color: #CCCCFF;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

#showHideSideBar:hover {
  background-color: #CCCCCC;
}
</style>
